import { ProductsSetupWizardPage } from '@/routes/app/ProductsSetupWizardPage';

export function ProfileLinkCardPage() {
  return <ProductsSetupWizardPage variant="profile-bc" />;
}
